export class AsyncRequestError extends Error {
  public code?: string;

  constructor(message: string = '', code?: string) {
    super(message);
    this.name = 'AsyncRequestError';
    this.message = message;
    this.code = code;
  }
}

export const isAsyncRequestError = (error: Error): boolean => error instanceof AsyncRequestError;
